// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as DeviceHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/DeviceHelpers.mjs";
import * as GAEventsConstants$PorterinFeature from "../../core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../core/helpers/PublishEventsHelper.mjs";

function downloadGaEvent(category) {
  if (category === "Fare Estimate Result") {
    PublishEventsHelper$PorterinFeature.publishEvents(category, GAEventsConstants$PorterinFeature.gaDownloadLinkFare, undefined);
  } else {
    PublishEventsHelper$PorterinFeature.publishEvents(category, DeviceHelpers$PorterinUtils.isIOS(undefined) ? GAEventsConstants$PorterinFeature.gaDownloadLinkIos : GAEventsConstants$PorterinFeature.gaDownloadLinkAndroid, undefined);
  }
}

function showStickyBasedOnScroll(heightShowFrom, setIsStickyHidden) {
  var winScroll = (document.body.scrollTop || document.documentElement.scrollTop);
  if (winScroll < heightShowFrom) {
    return Curry._1(setIsStickyHidden, false);
  }
  
}

function hideStickyBasedOnScroll(rootMargin, threshold, containerRef, isStickyHidden, setIsStickyHidden) {
  var node = containerRef.current;
  if (node == null) {
    return ;
  }
  var observer = new IntersectionObserver((function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting) {
            return Curry._1(setIsStickyHidden, !isStickyHidden);
          }
          
        }), {
        rootMargin: rootMargin,
        threshold: threshold
      });
  observer.observe(node);
  return (function (param) {
            observer.disconnect();
          });
}

export {
  downloadGaEvent ,
  showStickyBasedOnScroll ,
  hideStickyBasedOnScroll ,
}
/* DeviceHelpers-PorterinUtils Not a pure module */
